import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

const CURRENT_CUSTOMER_GAMES_ENDPOINT = "v1/currentcustomergames";

@Injectable({
	providedIn: "root",
})
export class UserGamesConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getCacheMaxAgeDefault(): number {
		return fromMinutesToMilliseconds(this.service.get((x) => x.gaming.userGames.cache!.default, 30));
	}

	getCacheMaxAgeForAllLastPlayed(): number {
		return this.service.get((x) => x.gaming.userGames.cacheMaxAge!.lastPlayed, this.getCacheMaxAgeDefault());
	}

	getAllLastPlayedEndpoint(): string {
		return this.service.get(
			(x) => x.gaming.userGames.endpoints!.lastPlayed,
			`${CURRENT_CUSTOMER_GAMES_ENDPOINT}/lastplayed?$fields=id`
		);
	}

	getGameIdsHiddenFromLastPlayed(): string[] {
		return this.service.get((x) => x.gaming.userGames.gameIdsHiddenFromLastPlayed, []);
	}
}
